import React, { Component } from "react";
import { getDeliveries } from "../../../../../services/inventory/deliveryService";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import { formatDate } from "../../../../../utils/utils";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import NumberFormat from "react-number-format";
import withGlobalData from "../../../common/withGlobalData";
import DeliveryDetail from "../../../inventory/stock-management/delivery/deliveryDetail";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
class SoGoodsIssued extends Component {
  state = {
    reload: this.props.globalData.reload,
    issuedItems: [],
    openDeliveryDetail: false,
    deliveryID: 0,
    itemIssuedDetailColumn: [
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getIssuedItems();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getIssuedItems();
      this.setState({ reload: globalData.reload });
    }
  }

  async getIssuedItems() {
    const { soID = 0 } = this.props;
    const response = await getDeliveries(soID, 0, 0);
    const { data } = response.data;
    this.setState({
      issuedItems: data.deliveries,
    });
  }

  render() {
    const {
      issuedItems,
      openDeliveryDetail,
      deliveryID,
      itemIssuedDetailColumn,
    } = this.state;
    return (
      <React.Fragment>
        {issuedItems.length ? (
          <React.Fragment>
            <CustomDataTable
              data={issuedItems}
              dataDetailColumns={itemIssuedDetailColumn}
              onRefreshData={() => {
                this.getIssuedItems();
              }}
              columns={[
                {
                  header: "Delivery ID",
                  field: "ID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Delivery Date",
                  field: "deliveryDate",
                  body: (rowData) => formatDate(rowData.deliveryDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      <BootstrapTooltip title="Goods Issued Detail">
                        <button
                          type="button"
                          onClick={() => {
                            this.setState({ deliveryID: rowData.ID });
                            this.handleOpenDialog();
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-list-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Illustration
              imageSource="INVIFO Inventory.png"
              guidance={`You don't have any Goods Issued for this sales order yet`}
              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
              size="md"
            ></Illustration>
          </React.Fragment>
        )}
        <DialogLayout
          open={openDeliveryDetail}
          title="Goods Issued Detail"
          onCloseDialog={() => {
            this.handleCloseDialog();
          }}
          minHeight={true}
        >
          <DeliveryDetail deliveryID={deliveryID} />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => {
                this.handleCloseDialog();
              }}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
          </DialogActions>
        </DialogLayout>
      </React.Fragment>
    );
  }

  handleOpenDialog = () => {
    this.setState({ openDeliveryDetail: true });
  };

  handleCloseDialog = () => {
    this.setState({ openDeliveryDetail: false });
  };
}

export default withGlobalData(SoGoodsIssued);
